import React from 'react';
import { Modal } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { hostUrlConverter, imgUrlConverter } from "../../util";
import { gaPackageBrowselinkedSection } from "../../util/googleAnalytics";

export const LinkedProducts = React.memo(({ showCustomize, linkedProducts, setShowCustomize, altImage, product, fromGradPackages }) => {

	const navigate = (productObj) => {
		!fromGradPackages && gaPackageBrowselinkedSection(product,productObj?.publishedCatalogProductId);
		let redirectUri = hostUrlConverter(productObj?.actionUrl);
		window.location.assign(redirectUri);
	}

	return (
		<Modal
			size='md'
			show={showCustomize}
			onHide={() => setShowCustomize(false)}>
			<Modal.Header closeButton>
				<Modal.Title> choose a style to start your design</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className='linked-products'>
					{linkedProducts?.length > 0 &&
						linkedProducts.map((productObj, key) => (
							<div key={key} onClick={()=>{navigate(productObj)}}>
								<LazyLoadImage
									src={imgUrlConverter(productObj?.imageUrl || altImage, 'product_md')}
									alt={productObj?.displayName}
									onClick={()=>{navigate(productObj?.actionUrl)}}
									onError={(e) => e.target.src = altImage}
								/>
								<div className='fa-xs mt-2 product-info'>
									<div>
											<div className='cursorPointer product-name-font'>
												{productObj?.displayName}
											</div>
									</div>
									${productObj?.retailPrice}
								</div>
							</div>
						))}
				</div>
			</Modal.Body>
		</Modal>
	);
});